import { ConversationsEventPayloadMap } from 'apis/auditLogs';

/**
 * Human-readable labels for the conversation audit-log event types. Keyed by
 * every event declared in {@link ConversationsEventPayloadMap} so the mapping
 * stays exhaustive. If an event type should not be selected as a filter, its label can be set to `undefined` to hide it from the list.
 */
export const conversationEventTypeLabels: Record<
  keyof ConversationsEventPayloadMap,
  string | undefined
> = {
  AUTOMATION_STARTED: 'Routed through automation',
  CHATBOT_TOOL_CALLED: 'AI agent tool called',
  CONVERSATION_ASSIGNED: 'Conversation assigned',
  CONVERSATION_AUTOREPLY_SENT: 'Autoreply sent',
  CONVERSATION_ADDED_TO_QUEUE: 'Added to queue',
  CONVERSATION_CHANNEL_CHANGED: 'Channel updated to',
  CONVERSATION_CLAIMED: 'Conversation claimed',
  CONVERSATION_CLOSED: 'Conversation closed',
  CONVERSATION_CREATED_BY_AGENT: 'Created by agent',
  CONVERSATION_CREATED_BY_CUSTOMER: 'Created by customer',
  CONVERSATION_CUSTOM_ATTRIBUTES_UPDATED: 'Custom attributes updated',
  CONVERSATION_END_USER_REPLACED: 'End user replaced',
  CONVERSATION_LANGUAGE_UPDATED: 'Language changed',
  CONVERSATION_LINKED_FROM_CHILD: 'Linked from child',
  CONVERSATION_LINKED_TO_PARENT: 'Linked to parent',
  CONVERSATION_MESSAGE_REDACTED: 'Message redacted',
  CONVERSATION_OFFERED: 'Conversation offered',
  CONVERSATION_OFFER_ACCEPTED: 'Offer accepted',
  CONVERSATION_OFFER_REJECTED: 'Offer rejected',
  CONVERSATION_OFFER_TIMEOUT: 'Offer timeout',
  // This event type is deprecated and it's kept for backwards compatibility
  CONVERSATION_PENDING: undefined,
  CONVERSATION_RATED: 'Conversation rated',
  CONVERSATION_RATING_CANCELLED: 'Rating cancelled',
  CONVERSATION_RATING_NOT_OFFERED: 'Rating not offered',
  CONVERSATION_RATING_OFFERED: 'Rating offered',
  CONVERSATION_RATING_SCHEDULED: 'Rating scheduled',
  CONVERSATION_RATING_UNSCHEDULED: 'Rating unscheduled',
  CONVERSATION_REOPENED: 'Conversation reopened',
  CONVERSATION_RESERVED: 'Conversation reserved',
  CONVERSATION_ROUTED_THROUGH_FLOW: 'Routed through flow',
  CONVERSATION_SLA_EVALUATION: 'SLA evaluation',
  CONVERSATION_SUBJECT_UPDATED: 'Subject updated',
  CONVERSATION_TRANSCRIPTION_ENDED: 'Transcription ended',
  CONVERSATION_TRANSCRIPTION_STARTED: 'Transcription started',
  CONVERSATION_UNASSIGNED: 'Conversation unassigned',
  CONVERSATION_UNLINKED_FROM_CHILD: 'Unlinked from child',
  CONVERSATION_UNLINKED_TO_PARENT: 'Unlinked to parent',
  FOLLOWUP_ADDED: 'Follow-up added',
  FOLLOWUP_EXPIRED: 'Follow-up expired',
  FOLLOWUP_REMOVED: 'Follow-up cancelled',
  MESSAGE_ADDED_BY_AGENT: 'Message added by agent',
  MESSAGE_ADDED_BY_CUSTOMER: 'Message added by customer',
  NOTE_ADDED: 'Internal note added',
  TAG_ADDED: 'Tag added',
  TAG_REMOVED: 'Tag removed',
  TRANSFER_FAILED: 'Transfer failed',
  TRANSFER_INITIATED: 'Transfer initiated',
  TRANSFER_SUCCESSFUL: 'Transfer successful',
};
